import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import Badge from "../../../../components/Badge";
import {WmsTaskStatus, WMSTaskStatusColor} from "../../../../utils/WMSTaskStatus";

TaskStatusDisplay.propTypes = {
    missionStatus: PropTypes.string.isRequired,
    isPartiallyComplete: PropTypes.bool.isRequired
};

function TaskStatusDisplay({missionStatus, isPartiallyComplete}) {

    const isPartiallyCompleteColor = missionStatus === WmsTaskStatus.CANCELLED && isPartiallyComplete && WmsTaskStatus.PARTIALLY_COMPLETE

    return (
        <Badge rounded color={WMSTaskStatusColor[isPartiallyCompleteColor || missionStatus]}>
            <FormattedMessage id={`wms.mission.status.${isPartiallyCompleteColor || missionStatus}`} />
        </Badge>
    );
}

export default TaskStatusDisplay;